import type { RcsBotListComposerState } from 'Pages/RcsBot/types'
import { atom } from 'recoil'

export const composerState = atom<RcsBotListComposerState>({
  key: 'RcsBotcomposerState',
  default: {
    token: '',
    brandName: '',
    dynamicFields: [],
    senderPhoneNumbers: [],
    senderAlias: [],
  },
})
